import { call, put, takeEvery } from 'redux-saga/effects';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { removeProductFromBasket } from './RemoveProductFromBasketSaga';
export function* removeProductAndUpdate(action) {
    yield call(removeProductFromBasket, action);
    yield put(basketActions.createGetBasicAction());
    yield put(basketActions.createGetAction());
}
export function* removeProductAndUpdateSaga() {
    yield takeEvery(BasketActionTypes.REMOVE_PRODUCT_AND_UPDATE, removeProductAndUpdate);
}
